import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AlertMessageComponent from "../../pages/components/AlertMessageComponent";
import FetchingSpinner from "../../pages/components/FetchingSpinner";
import { apiGatewayAxiosInstance } from "../../utils/axios";
import SendOTP from "./SendOTP";


export default function FirstLogInComponent() {
    const navigate = useNavigate();
    const [clientData, setClientData] = useState({});
    const [pageLoading, setPageLoading] = useState(true);
    const [otpVerified, setOTPVerified] = useState(false);
    const [otpSent, setOTPsent] = useState(false);

    const [mobileNumberOTP, setMobileNumberOTP] = useState("");
    const [otpVerificationLoading, setOTPVerificationLoading] = useState(false);

    const [otpLoading, setOTPLoading] = useState(false);
    const [errorResponse, setErrorResponse] = useState("");
    const { userId } = useParams();
    const [userData, setUserData] = useState({});
    const [userDataLoading, setUserDataLoading] = useState(false);

    const getUserDataByUserId = async (userId) => {
        try {
            setPageLoading(true)
            setUserDataLoading(true);
            const response = await apiGatewayAxiosInstance.get(`/user_management/users/get-user-data-by-id`, { headers: { userId: userId } });
            if (response.status === 200) {
                setUserData(response?.data?.data);
            }
            setUserDataLoading(false);
        } catch (error) {
            let errorMessage = "Server not reachable.";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            setErrorResponse(errorMessage);
            setUserDataLoading(false);
        }

        setPageLoading(false)
    }

    const sendOTPTomobileNumber = async () => {
        try {
            setOTPLoading(true);
            const response = await apiGatewayAxiosInstance.get(`/user_management/clients/send-OTP`, {
                params: { registryId: userData?.registryId, orgId: userData?.orgId, roleName: userData?.roleName },
                headers: { userid: userData?._id }
            });
            if (response.status === 200) {
                setOTPsent(true);
            }

            setOTPLoading(false);
        } catch (error) {
            let errorMessage = "Server not reachable.";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            setErrorResponse(errorMessage);
            setOTPLoading(false);
        }
    };
    const verifyOTPTomobileNumber = async () => {
        try {
            setOTPVerificationLoading(true);
            const response = await apiGatewayAxiosInstance.get(`/user_management/clients/verify-OTP`, {
                params: { registryId: userData?.registryId, orgId: userData?.orgId, roleName: userData?.roleName, mobileNumberOTP },
                headers: { userid: userData?._id }
            });
            if (response.status === 200) {
                setOTPVerified(true);
                setOTPVerificationLoading(false);
                navigate(`/auth/first-login-reset-password/${userData._id}`);
            }
        } catch (error) {
            setOTPVerificationLoading(false);
            let errorMessage = "Server not reachable.";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            setErrorResponse(errorMessage);
        }
    };
    useEffect(async () => {
        await getUserDataByUserId(userId)
    }, []);

    return (
        <div>
            {pageLoading ? (
                <FetchingSpinner />
            ) : userData &&
            (<SendOTP
                orgUserId={userData._id}
                clientData={userData}
                sendOTPTomobileNumber={sendOTPTomobileNumber}
                mobileNumberOTP={mobileNumberOTP}
                setMobileNumberOTP={setMobileNumberOTP}
                verifyOTPTomobileNumber={verifyOTPTomobileNumber}
                otpSent={otpSent}
                otpLoading={otpLoading}
                otpVerificationLoading={otpVerificationLoading}
            />)
            }
            < AlertMessageComponent
                message={errorResponse}
                fieldName={"errorResponse"}
                handleClose={() => setErrorResponse("")}
                show={Boolean(errorResponse)}
            />
        </div>
    );
}
